module.exports = __webpack_public_path__ + "media/styles/images/png/ex-white-0d79838c626ee0269be5fcc9c45951d7.png";